import * as React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../types';
import { FlexBox } from '../../flex-box';
import { PlainButton } from '../../button';

interface ICloseButtonProps extends IBaseComponentProps {
    onClick(): void;
    onRenderCloseIcon?(): React.ReactNode;
}

function CloseButtonBase(props: ICloseButtonProps) {
    const { className, onClick, onRenderCloseIcon } = props;

    const renderCloseIcon = React.useCallback(() => {
        if (onRenderCloseIcon === undefined) {
            return <PlainButton size="small" iconName="ap-close2.outline" iconSize="12" title="Close"/>;
        }
        return onRenderCloseIcon();
    }, [onRenderCloseIcon]);

    return (
        <FlexBox alignItems="center" justifyContent="center" className={className} onClick={onClick}>{renderCloseIcon()}</FlexBox>
    );
}

export const CloseButton = styled(CloseButtonBase)`
    position: absolute;
    top: 0px;
    right: 0px;
`;
